import {
  Dashboard,
  ProfileCompletionSuccess,
  ProfileCreation,
  UserProfile,
} from "../../app/pages";
// import LinkVerificationError from "../../app/pages/CertificateManagement/BankRep/LinkVerificationError";
// import OTPVerification from "../../app/pages/CertificateManagement/BankRep/OTPVerification";
import { appUrls } from "../../utils/urls/appUrls";
import { notapRoutes } from "./notapRoutes";
import { onBoardRoutes } from "./onBoardRoutes";

export const generalProtectedRoutes = [
  // {
  // 	url: appUrls.upload_certificate_of_reasonableness,
  // 	component: <OTPVerification />,
  // 	routeType: 'public'
  // },
  // {
  // 	url: appUrls.upload_link_verification_error,
  // 	component: <LinkVerificationError />,
  // 	routeType: 'public'
  // },
  {
    url: appUrls.profileCreation,
    component: <ProfileCreation />,
    routeType: "private",
  },
  {
    url: appUrls.profileCreationSuccess,
    component: <ProfileCompletionSuccess />,
    routeType: "private",
  },
  {
    url: appUrls.user_profile,
    component: <UserProfile />,
    routeType: "private",
  },
  ...onBoardRoutes,
  ...notapRoutes,
];
